import React from 'react';
import './MetricCard.css';

export default function MetricCard({ icon, value, label, trend, color }) {
  return (
    <div className="metric-card">
      <div className="metric-card__icon" style={color ? { color } : undefined}>
        {icon}
      </div>
      <div className="metric-card__value">{value}</div>
      <div className="metric-card__label">{label}</div>
      {trend !== undefined && (
        <div className={`metric-card__trend ${trend >= 0 ? 'metric-card__trend--up' : 'metric-card__trend--down'}`}>
          {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}%
        </div>
      )}
    </div>
  );
}
